<div class="component-viewer">
    <mat-card>
        <mat-card-header style="display: inline;">
            <div class="row w-1oo">
                <div class="col-6 text-start">
                    <h2 class="mb-0">Scheduled Bookings</h2>
                </div>
                <div class="col-6 text-end">
                    <button mat-raised-button (click)="onCreate()">Add <mat-icon>add</mat-icon></button>
                </div>
            </div>
        </mat-card-header>
        <mat-card-content>
            <div class="row w-75">
                <div class="col-md-4">
                    <mat-form-field appearance="outline" class="date-field">
                        <mat-label>From Date</mat-label>
                        <input matInput [matDatepicker]="fromPicker" [(ngModel)]="filter.fromDate"
                            (dateChange)="getScheduledBookings()">
                        <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
                        <mat-datepicker #fromPicker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field appearance="outline" class="date-field">
                        <mat-label>To Date</mat-label>
                        <input matInput [matDatepicker]="toPicker" [(ngModel)]="filter.toDate"
                            (dateChange)="getScheduledBookings()">
                        <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
                        <mat-datepicker #toPicker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field appearance="outline" class="date-field">
                        <mat-label>Type</mat-label>
                        <mat-select [(ngModel)]="filter.scheduledBookingType" (selectionChange)="getScheduledBookings()">
                            <mat-option [value]="null">All Types</mat-option>
                            <mat-option *ngFor="let type of scheduledBookingTypes" [value]="type.type">
                                {{type.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <gt-table *ngIf="true" [loading]="isLoading" [defaultPageSize]="10" [updateFilterEvent]="updateFilterEvent"
                [filter]="filter" [data]="scheduledBookings" (filterChanged)="getScheduledBookings()"
                (filterReset)="resetFilter()" [placeholder]="'Search by scheduled booking name'">
            </gt-table>
            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
            <table mat-table [dataSource]="scheduledBookings" matSort (matSortChange)="sortData($event)">
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="name"> Name </th>
                    <td mat-cell *matCellDef="let scheduledBooking"> {{scheduledBooking.name}} </td>
                </ng-container>
                <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="type"> Type </th>
                    <td mat-cell *matCellDef="let scheduledBooking">
                        {{getScheduledBookingTypeLabel(scheduledBooking.type)}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="hasPaidBooking">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="hasPaidBooking"> Has Paid </th>
                    <td mat-cell *matCellDef="let scheduledBooking">
                        <true-false *ngIf="scheduledBooking.hasPaidBooking" [value]="scheduledBooking.hasPaidBooking" [trueMatIcon]="'paid'" [trueText]="'Yes'"></true-false>
                        <true-false *ngIf="!scheduledBooking.hasPaidBooking" [value]="scheduledBooking.hasPaidBooking" [falseMatIcon]="'error_outline'" [falseText]="'No'"></true-false>
                    </td>
                </ng-container>
                <ng-container matColumnDef="startDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="startDate"> Start Date </th>
                    <td mat-cell *matCellDef="let scheduledBooking">
                        {{formatInUserTimezone(scheduledBooking.startTime, 'MM/DD/YYYY')}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="endDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="endDate"> End Date </th>
                    <td mat-cell *matCellDef="let scheduledBooking">
                        {{formatInUserTimezone(scheduledBooking.endTime, 'MM/DD/YYYY')}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="timeSlot">
                    <th mat-header-cell *matHeaderCellDef> Time Slot </th>
                    <td mat-cell *matCellDef="let scheduledBooking">
                        {{formatInUserTimezone(scheduledBooking.startTime, 'h:mm A')}} -
                        {{formatInUserTimezone(scheduledBooking.endTime, 'h:mm A')}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="price">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="price"> Price </th>
                    <td mat-cell *matCellDef="let scheduledBooking">
                        {{scheduledBooking.price | currency}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="simulators">
                    <th mat-header-cell *matHeaderCellDef> Simulators </th>
                    <td mat-cell *matCellDef="let scheduledBooking">
                        {{getSimulatorNames(scheduledBooking.simulatorIds)}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef> Actions </th>
                    <td mat-cell *matCellDef="let scheduledBooking">
                        <button mat-icon-button [matMenuTriggerFor]="actionsMenu" *ngIf="!isEndDatePassed(scheduledBooking)">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                         <mat-menu #actionsMenu>
                             <button mat-menu-item (click)="onEdit(scheduledBooking)">
                                <mat-icon>edit</mat-icon>
                                <span>Edit</span>
                            </button>
                            <button mat-menu-item (click)="onDelete(scheduledBooking)" *ngIf="!isEndDatePassed(scheduledBooking)">
                                <mat-icon>delete</mat-icon>
                                <span>Delete</span>
                            </button>
                            <button mat-menu-item (click)="onResendPaymentLink(scheduledBooking)" *ngIf="canResendPaymentLink(scheduledBooking)">
                                <mat-icon>send</mat-icon>
                                <span>Resend Payment Link</span>
                            </button>
                         </mat-menu>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </mat-card-content>
    </mat-card>
</div>